import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { ActionModal } from 'portal-modules/common/components/modals'
import { PdfView } from 'portal-modules/documents/components'
import Api from 'App/api'
import Media from 'react-media'
import { StyledIconButton } from 'portal-modules/common/components/cards/atoms'
const StyledAnchor = StyledIconButton.withComponent('a')
import { FocusSpan } from 'portal-modules/common/components/focus-styles'
import { Download, Plus, Minus } from '@entrata/portals-common/lib/icons'
import styled from '@emotion/styled'

const StyledOuterDiv = styled('div')`
  position: relative;
`
const StyledActionButtonDiv = styled('div')`
  float: left;
  right: 10px;
  z-index: 1;
  display: flex;
  justify-content: center;
  position: fixed;
  top: 55px;
`
const StyledButtonIcon = styled('button')`
  background: transparent;
  color: ${({ theme }) => theme.backgroundColor.white};
  height: 24px;
  padding: 0;
  width: 24px;
  border: none;
  outline: none;
  margin-right: 4px;
  border: 1px solid;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    margin-top: 3px;
    outline: none;
  }
  svg {
    outline: none;
  }
`

const InvoiceDocumentModal = ({ document_id, token, history, ...rest }) => {
  const [isScale, setScale] = useState(1.0)

  const handleZoomInAndOut = scale => {
    setScale(scale)
  }

  return (
    <ActionModal {...rest} cancelText={__('Close')} isWideDialog>
      {props =>
        rest.show && (
          <StyledOuterDiv>
            <StyledActionButtonDiv>
              <StyledButtonIcon
                onClick={() => {
                  const scaleIn = isScale + 0.2
                  handleZoomInAndOut(scaleIn)
                }}
              >
                <FocusSpan>
                  <Plus size={24} title={__('Zoom In')} />
                </FocusSpan>
              </StyledButtonIcon>
              <StyledButtonIcon
                onClick={() => {
                  if (isScale > 1) {
                    let scaleOut = isScale - 0.2
                    handleZoomInAndOut(scaleOut)
                  }
                }}
              >
                <FocusSpan>
                  <Minus size={24} title={__('Zoom Out')} />
                </FocusSpan>
              </StyledButtonIcon>
              <Media query='(min-width: 370px)'>
                {notMobile =>
                  notMobile && (
                    <StyledAnchor
                      href={Api.getUrl(
                        { controller: 'documents', action: 'download' },
                        { id: document_id, auth_token: token },
                      )}
                      rel='noopener noreferrer'
                      target='_blank'
                      title={__('Download')}
                    >
                      <FocusSpan>
                        <Download size={20} title={__('Download')} />
                      </FocusSpan>
                    </StyledAnchor>
                  )
                }
              </Media>
            </StyledActionButtonDiv>
            <div>
              <PdfView
                marketingName={'ViewInvoice.pdf'}
                file={Api.getUrl(
                  { controller: 'documents', action: 'download' },
                  { id: document_id },
                )}
                history={history}
                scale={isScale}
              />
            </div>
          </StyledOuterDiv>
        )
      }
    </ActionModal>
  )
}

InvoiceDocumentModal.propTypes = {
  document_id: PropTypes.number,
  token: PropTypes.string,
  history: PropTypes.object,
}

export default InvoiceDocumentModal
